var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SylController } from '@syllepsis/adapter';
import { TextSelection } from 'prosemirror-state';
import { PLUGIN_NAME, setConfig } from './config';
var WRAP = String.fromCharCode(10);
var setCodeBlock = function (editor, language) {
    var _a = editor.view, state = _a.state, dispatch = _a.dispatch;
    var schema = state.schema, selection = state.selection, doc = state.doc;
    var from = selection.from, to = selection.to, $from = selection.$from;
    var selectTextLen = doc.textBetween(from, to, WRAP).length;
    var tr = state.tr;
    var codeText = '';
    var start;
    var end;
    doc.nodesBetween(from, to, function (node, pos) {
        if (node.isTextblock) {
            if (start === undefined) {
                start = pos;
            }
            end = pos + node.nodeSize;
            node.content.forEach(function (child) {
                if (child.isText)
                    codeText += child.textContent;
                if (child.type.name === 'break')
                    codeText += WRAP;
            });
            codeText += WRAP;
            return false;
        }
    });
    codeText = codeText.substring(0, codeText.length - 1);
    if (start === undefined || end === undefined)
        return;
    var newCode = schema.nodes.code_block.create(language ? { language: language } : undefined, codeText ? schema.text(codeText) : undefined);
    var $start = editor.view.state.doc.resolve(start);
    var $end = editor.view.state.doc.resolve(end);
    var newFrom = from;
    // if neither at top nor first node, fix from
    if ($start.depth && $start.indexAfter()) {
        newFrom += $start.depth;
    }
    else {
        newFrom -= $from.depth - 1;
    }
    // nested node needs to contain it's parent
    if ($start.depth && !$start.indexAfter()) {
        start = $start.pos - $start.depth;
    }
    if ($end.depth && $end.indexAfter() === $end.parent.childCount) {
        end = $end.pos + $end.depth;
    }
    tr = tr.replaceRangeWith(start, end, newCode);
    dispatch(tr.setSelection(TextSelection.create(tr.doc, newFrom, newFrom + selectTextLen)));
    editor.focus();
};
var clearCodeBlock = function (editor) {
    var _a = editor.view, dispatch = _a.dispatch, state = _a.state;
    var schema = state.schema, tr = state.tr, selection = state.selection;
    var $from = selection.$from, $to = selection.$to;
    var node = $from.node();
    var nodePos = $from.before();
    var textContents = node.textContent.split(WRAP);
    var fragments = textContents.reduce(function (res, text) {
        if (text) {
            res.push(schema.text(text));
        }
        res.push(schema.nodes.break.create());
        return res;
    }, []);
    fragments.pop();
    dispatch(tr
        .replaceRangeWith(nodePos, nodePos + node.nodeSize, schema.nodes.paragraph.create(undefined, fragments))
        .setSelection(TextSelection.create(tr.doc, $from.pos, $to.pos)));
    editor.focus();
};
var CodeBlockController = /** @class */ (function (_super) {
    __extends(CodeBlockController, _super);
    function CodeBlockController(editor, props) {
        var _this = _super.call(this, editor, props) || this;
        _this.name = PLUGIN_NAME;
        _this.toolbar = {
            className: PLUGIN_NAME,
            tooltip: PLUGIN_NAME,
            handler: function (editor) {
                var $from = editor.view.state.selection.$from;
                if ($from.parent.type.name === PLUGIN_NAME) {
                    _this.command.clearCodeBlock(editor);
                }
                else {
                    _this.command.setCodeBlock(editor, _this.props.mode);
                }
            },
        };
        _this.command = {
            setCodeBlock: function (editor, mode) {
                setCodeBlock(editor, mode || _this.props.mode);
                _this.props.afterInsert && _this.props.afterInsert(editor);
            },
            clearCodeBlock: function (editor) {
                clearCodeBlock(editor);
            },
        };
        _this.keymap = {
            Backspace: function (editor, state, dispatch) {
                var _a = state.selection, $from = _a.$from, empty = _a.empty;
                if (!empty || $from.nodeBefore)
                    return false;
                var beforePos = $from.before();
                var prevNode = state.doc.resolve(beforePos).nodeBefore;
                if (!prevNode || prevNode.type.name !== PLUGIN_NAME || prevNode.childCount)
                    return false;
                dispatch(state.tr.join(beforePos));
                return true;
            },
        };
        setConfig(props);
        return _this;
    }
    return CodeBlockController;
}(SylController));
export { CodeBlockController };
//# sourceMappingURL=controller.js.map